import styled from 'styled-components';

const Styles = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  
  .table-content {
    flex: 1;
    overflow-y: auto;
  }

  .view-page-tabs {
    .ant-tabs-nav-list {
      padding-left: var(--size-lg);
      padding-right: var(--size-lg);
    }
  }

  .ant-input-affix-wrapper-disabled  {
    background-color: transparent;
    cursor: pointer;
    color: rgba(0, 0, 0, 0.65);
    input {
      background-color: transparent;
      cursor: text;
      color: rgba(0, 0, 0, 0.65);
    }
  }
  .columns {
    span[role="img"] {
      margin-left: 8px
    }
  }
  .projectLink {
    color: rgba(0, 0, 0, 0.7);
    font-weight: 500;
    text-decoration: underline;
  }
  .ant-drawer-body {
    padding: 0;
  }
  .ant-table.ant-table-small .ant-table-tbody .ant-table-wrapper:only-child .ant-table {
    margin: 10px;
  }
  .ant-table-expanded-row.ant-table-expanded-row-level-1 {
    background: rgba(0, 0, 0, 0.08);
  }
`;

export default Styles;
